import ModalMuiTable from "../../../Components/Modals/ModalMuiTable.jsx";
import OfftakeFilter from "../../../Components/Filters/OfftakeFilter.jsx";

export const OfftakeTableDetailed = ({ closeModal }) => {
  // const offtakeColumns = [
  //   { header: "Region", accessorFn: (value) => value.REGION },
  //   { header: "State", accessorFn: (value) => value.STATE },
  //   { header: "State Office", accessorFn: (value) => value.X_SLS_AREA },
  //   { header: "Dealer Name", accessorFn: (value) => value.DEALER_NAME },
  //   { header: "Dealer Code", accessorFn: (value) => value.DEALER_CODE },
  //   { header: "Product Line", accessorFn: (value) => value.Product_Line },
  //   { header: "LOB", accessorFn: (value) => value.LOB },
  //   { header: "PPL", accessorFn: (value) => value.PPL },
  //   { header: "PL", accessorFn: (value) => value.PL },
  //   { header: "VC#", accessorFn: (value) => value.VC },
  //   {
  //     header: "Regulatory Norms",
  //     accessorFn: (value) => value.REGULATORY_NORMS,
  //   },
  //   {
  //     header: "Offtake Count",
  //     accessorFn: (value) => value.TEMP_OFFTAKE,
  //   },
  // ];

  return (
    <div>
      <ModalMuiTable
        open={true}
        sliceName={"filtersOfftake"}
        FilterComponent={OfftakeFilter}
        heading={"Offtake Detailed Report"}
        apiEndpoint={"offtake/detailed-report"}
        onClose={closeModal}
      />
    </div>
  );
};

export default OfftakeTableDetailed;
